import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons/faBadgeCheck'
import type { GeolocationWithLocationName } from '@lib/types/Geolocation'
import calculateDistance from '@lib/utilities/calculateDistance'
import { isTrialSiteMonetized } from '@modules/facilities/helpers/isTrialSiteMonetized'
import {
  cityStatecodeString,
  locationToPoint,
} from '@modules/trials/helpers/parseLocationsFromTrial/parseTruncatedLocationsFromTrial'
import type { TrialLocationNarrow } from '@modules/trials/types/TrialAssociatedWithLocations'
import isNil from 'lodash/isNil'

export const ClosestSiteText = ({
  closestSite,
  includeDistance = false,
  userLocation,
}: {
  closestSite: TrialLocationNarrow
  includeDistance?: boolean
  userLocation?: GeolocationWithLocationName
}) => {
  if (!userLocation) {
    return null
  }

  const distanceCalculated = calculateDistance(
    locationToPoint(closestSite),
    userLocation,
  )

  const distanceFromSite =
    includeDistance && distanceCalculated
      ? Math.ceil(distanceCalculated)
      : undefined

  return (
    <div className='space-x-2'>
      <Text
        className='inline text-neutral900'
        styleName='h5'
        value={'Closest Location:'}
      />
      <Text
        className='inline text-neutral600'
        styleName='p-strong'
        value={`${closestSite.facility}`}
      />
      {isTrialSiteMonetized(closestSite) && (
        <Icon className='text-blue500' icon={faBadgeCheck} />
      )}
      <Text
        className='inline text-neutral600'
        styleName='p-strong'
        value={`· ${cityStatecodeString(closestSite)}`}
      />
      {!isNil(distanceFromSite) && (
        <Text className='inline' value={`· ${distanceFromSite} miles`} />
      )}
    </div>
  )
}
